export function StampDutyDisclaimer() {
  return (
    <div className="text-xs leading-5 text-gray-500">
      Always verify with Bare Acts before relying
    </div>
  );
}
